import { handlePostAction } from "../../../utils/event-api-invoke";
import { getMarketSectorAPIPostSchema, getMarketSectorAuditInfoSchema } from "../create/Schema";

let _isError = false;

const getAuditInfo = (data, auditConfig) => {
  try {
    let _auditSchema = getMarketSectorAuditInfoSchema();
    let _currentState = {};
    let _prevState = {};
    let _isDeleted = data?.Deleted;
    Object.keys(data).forEach((key) => { //If the record is deleted, previousState will be available. The currentState will be available for creation.
      if(_isDeleted){
        if(key !== "Deleted"){ //We do not send deleted key in state
          _prevState[key] = data[key];
        } 
      }else{
        _currentState[key] = data[key];
        _prevState[key] = auditConfig.formdata?.[key]; //formdata will only be available in edit scenario
      }
    });

    _auditSchema.auditInfo[0].shortDesc = data?.SectorName;
    _auditSchema.auditInfo[0].currentState = JSON.stringify(_currentState);
    _auditSchema.auditInfo[0].previousState = JSON.stringify(_prevState);
    if (auditConfig.editMarketSectorId) {
      _auditSchema.auditInfo[0].LocationKey = auditConfig.editMarketSectorId;
      _auditSchema.auditInfo[0].Action = _isDeleted ? "DELETE" : "EDIT";
    } else {
      _auditSchema.auditInfo[0].Action = "CREATE";
    }

    return _auditSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getPostPayload = (data, config) => {
  try {
    let _postSchema = getMarketSectorAPIPostSchema(config.countryCode, config.businessCode);

    _postSchema.marketSector[0].SectorName = data?.SectorName;
    if (config.editMarketSectorId) {
      _postSchema.marketSector[0].SectorId = config.editMarketSectorId;
      _postSchema.marketSector[0].Deleted = data.Deleted ? data.Deleted : false;
    }

    return _postSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const saveMarketSector = async (data, uihandler) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  const {
    EditMarketSectorId: editMarketSectorId,
    settingsConfig: { businessCode, countryCode },
    formdata,
  } = uihandler;
  try {
    let _auditInfo = getAuditInfo(data, {editMarketSectorId, formdata });
    let _postPayload = getPostPayload(data, { editMarketSectorId, businessCode, countryCode });

    let _postRequest = { ..._postPayload, ..._auditInfo };

    let res = await handlePostAction(_postRequest, "marketsector");
    if (res && res.status && res.status === 200) {
      if (res.data.errorNumber > 0) {
        _isError = true;
        status.errorMessage = res.data.errorDescription;
      } else {
        status.responseStatus = res.status;
      }
    }

  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { saveMarketSector };
